<template>
	<div>
		<div v-if="$store.state.userInfo.page == 'super' || $store.state.userInfo.page == 'developer'">
			<template v-for="(child,index) in menuData" >
				<div v-if="child.hidden != true">
					<el-submenu v-if="child.children.length > 0" :index="child.path">
						<template slot="title">
							<i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>
							<span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
						</template>
						<menu-tree :menuData="child.children"></menu-tree>
					</el-submenu>
			
					<el-menu-item v-else :index="child.path">
						<i :class="child.iconCls?child.iconCls:[fa,fa-file]"></i>
						<span slot="title">{{ $t(`routeName.${child.name}`) }}</span>
					</el-menu-item>
				</div>
			
			</template>
		</div>
		
		<div v-else>
			<template v-for="(child,index) in menuData" >
				<el-submenu v-if="child.childs != null" :index="child.fnPath">
					<template slot="title">
						<span slot="title">{{child.fnName}}</span>
					</template>
					<menu-tree :menuData="child.childs"></menu-tree>
				</el-submenu>
			
				<el-menu-item v-else :index="child.fnPath" >
					<span slot="title">{{child.fnName}}</span>
				</el-menu-item>
			</template>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'menuTree',
		props: ['menuData'],
		methods:{

		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/aside/menuTree.vue